import AppForm from "../app-components/Form/AppForm";

var userLanguage = document.documentElement.lang;

Vue.component("employee-form", {
    mixins: [AppForm],
    props: {
        mode: {
            type: String,
            required: true
        },
        countryCodesList: {
            type: Array,
            required: true
        },
        nationalitiesList: {
            type: Array,
            required: true
        }
    },
    data: function() {
        return {
            form: {
                submit_type: "",
                restaurant_id: "",
                first_name: "",
                last_name: "",
                maiden_name: "",
                phone: "",
                phone_number: {
                    code: null,
                    number: null,
                },
                email: "",
                employment_start: "",
                mymcd_sync: "",
                personal_data: {
                    birth_date: null,
                    birth_place: null,
                    birth_number: null,
                    nationality: this.nationalitiesList[0].key,
                    marital_status: null,
                    identity_card_number: null,
                    iban: null,
                    health_insurance_company: null,
                    health_insurance_license_valid_to: null,
                    health_examination_valid_to: null,
                    achieved_education: null,
                    achieved_education_year: null,
                    achieved_education_school: null,
                    achieved_education_city: null,
                    achieved_education_major: null,
                    ztp: false,
                    gender: "male",
                    agency: false
                },
                dynamicFieldsValues: {}
            },
            datePickerConfig: {
                dateFormat: "Y-m-d 00:00:00",
                altInput: true,
                altFormat: "d.m.Y",
                locale: userLanguage,
                allowInput: true,
                onClose(dates, currentdatestring, picker) {
                    picker.setDate(
                        picker.altInput.value,
                        true,
                        picker.config.altFormat
                    );
                }
            },
            dateOnlyPickerConfig: {
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d.m.Y",
                locale: userLanguage,
                allowInput: true,
                onClose(dates, currentdatestring, picker) {
                    picker.setDate(
                        picker.altInput.value,
                        true,
                        picker.config.altFormat
                    );
                }
            },
            checkEmailTimeout: null
        };
    },

    created: function created() {
        if (!!this.locales && this.locales.length > 0) {
            var form = this.form;
            this.currentLocale = this.defaultLocale;
        }

        if (!_.isEmpty(this.data)) {
            this.form = this.data;
            if (!this.form.personal_data) this.form.personal_data = {};
            if (!this.form.dynamicFieldsValues)
                this.form.dynamicFieldsValues = {};
        }

        window.addEventListener("resize", this.onResize);
    },

    methods: {
        getPostData() {
            return this.form;
        },

        onSuccess(data) {
            this.submiting = false;

            this.$notify({
                type: "success",
                title: '<span class="fa fa-check"></span>',
                text: data.message
            });

            if (this.mode === "create" && data.redirect) {
                window.location.replace(data.redirect);
            }
            /*
            $(".button-save").hide().delay(1400).queue(function(next){
                $(this).fadeToggle("button-save");
                next();
            });

            $(".button-saved").show().delay(1000).queue(function(next){
                $(this).fadeToggle("button-saved");
                $(".edit-submit").css("pointer-events", "all");
                next();
            });
            */
        },

        fixPhoneFormat($event) {
            let numStr = String($event ? $event.target.value : (this.form.phone_number.number || '')).replace(/[^0-9]/g, "");
            this.form.phone_number.number = (numStr !== "" ? parseInt(numStr) : "");
        },

        checkEmail($event, timeout) {
            var _this = this;

            if (this.data.checkEmailTimeout)
                clearTimeout(this.data.checkEmailTimeout);

            this.data.checkEmailTimeout = setTimeout(function() {
                axios.post("check-email", { email: _this.form.email }).then(
                    function(response) {
                        _this.errors.remove("email");
                        if (
                            !response.data.status &&
                            response.data.validationError
                        ) {
                            _this.errors.add({
                                field: "email",
                                msg: response.data.validationErrorLocalized
                                    ? response.data.validationErrorLocalized
                                    : response.data.validationError
                            });
                        }
                    },
                    function(error) {
                        _this.$notify({
                            type: "error",
                            title: "Error!",
                            text: "An error has occured."
                        });
                    }
                );
            }, timeout);
        },

        // duplicate code - move to something shared (employee/Form + employee-contract/Form)
        correctDynamicFieldsDecimals(typeId, $event) {
            this.form.dynamicFieldsValues[typeId] = this.sanitizeDecimalPoint(
                $event.target.value
            );
        },

        formatDynamicFieldsAmount(typeId, $event) {
            let sanitized = this.sanitizeFloatInput($event.target.value, 2);
            if (sanitized + "" == "NaN") sanitized = "0.00";

            this.form.dynamicFieldsValues[typeId] = sanitized;
            $("#field_" + typeId).val(sanitized); // lebo vue je dementne a model sice refreshne, ale input s v-model uz nie
        },

        sanitizeDecimalPoint(val) {
            val = "" + val;
            return val ? val.replace(",", ".") : val;
        },

        sanitizeIncorrectFloatChars(val) {
            val = this.sanitizeDecimalPoint(val);
            return val
                ? val
                      .replace(/[^0-9\.]/, "")
                      .replace(/([0-9]+\.[0-9]+)\..*/, "$1")
                : val;
        },

        sanitizeFloatInput(val, minDecimals) {
            if (val == null) return val;

            var sanitized = parseFloat(this.sanitizeIncorrectFloatChars(val));
            if (
                (sanitized || sanitized === 0) &&
                this.countDecimals(sanitized) < minDecimals
            )
                sanitized = sanitized.toFixed(minDecimals);

            return sanitized + "";
        },

        countDecimals(value) {
            if (Math.floor(value) === value) return 0;
            var arr = value.toString().split(".");

            return arr.length == 2 ? arr[1].length : 0;
        }
    },
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/employee/Form.js